import React from 'react';
import ReactTooltip from 'react-tooltip';
import { createGlobalStyle } from 'styled-components';

interface SelectorTooltipProps {
  id: string;
  selector: string;
  image: string;
}

export function SelectorTooltip({
  id,
  selector,
  image: _image,
}: SelectorTooltipProps) {
  return (
    <>
      <SelectorTooltipWrapper />
      {/* @ts-ignore */}
      <ReactTooltip
        id={id}
        place="top"
        backgroundColor="#fff"
        textColor="#000"
        className="selector-tooltip"
      >
        <span>{selector}</span>
      </ReactTooltip>
    </>
  );
}

export const SelectorTooltipWrapper = createGlobalStyle`
  .selector-tooltip {
    display: grid!important;
    justify-content: center;
    align-items: center;
    align-content: center;
    justify-items: center;
    grid-gap: 0.5rem;
    flex-direction: column;
    box-shadow: 0 4px 5px 0 rgba(105, 122, 231, 0.11),
    0 12px 16px 0 rgba(196, 217, 210, 0.38), 0 1px 5px 0 rgba(0, 0, 0, 0.15);
    border-radius: 1rem!important;
    font-family: "JetBrains Mono",serif;
    opacity: 1!important;
    padding: 1.2rem!important;

    img {
      object-fit: contain;
      max-width: 200px;
      min-height: 100px;
    }
  }
`;
